import React from 'react';

export const LoadingSpinnerSmall = () => {
    return (
        <div className="d-flex align-items-center justify-content-center">
            <i className="fa fa-spinner fa-spin" />
        </div>
    );
};
